const pageNameKey = "snackbarNotifications";

export const snackbarNotificationsEn = {
  [pageNameKey]: {
    hiddenItemsNotificationText:
      "You selected additional data objects, which are not visible due to your filter. If you perform any action the visible and currently invisible data objects will be affected.",
    clearFilterMachineStructureToDragAndDrop:
      "Please clear filter view in machine structure to enable drag and drop again.",
    maximumAmountOfMonitoringNodesExceededNotification:
      "Possible latency of application caused by too many monitoring data point requests. Replace monitoring acquisition type with polling to enhance app performance.",
    blueprintAutomatchUnexpectedError:
      "An error occurred while trying to auto-match the blueprint.",
    blueprintLibraryUnexpectedError:
      "An error occurred while trying to fetch the blueprint library.",
  },
};

export const snackbarNotificationsPtBr = {
  [pageNameKey]: {
    hiddenItemsNotificationText:
      "Você selecionou objetos de dados adicionais que não estão visíveis devido ao filtro atual. Se executar qualquer ação, os objetos de dados visíveis e ocultos serão afetados.",
    clearFilterMachineStructureToDragAndDrop:
      "Remova o filtro da estrutura da máquina para habilitar novamente o recurso de arrastar e soltar.",
    maximumAmountOfMonitoringNodesExceededNotification:
      "A aplicação pode apresentar lentidão devido ao grande número de solicitações de pontos de monitoramento. Altere o tipo de aquisição para polling para melhorar o desempenho da aplicação.",
    blueprintAutomatchUnexpectedError:
      "Ocorreu um erro ao tentar fazer a correspondência automática do blueprint.",
    blueprintLibraryUnexpectedError:
      "Ocorreu um erro ao tentar buscar a biblioteca de blueprints.",
  },
};

export const snackbarNotificationsDe = {
  [pageNameKey]: {
    hiddenItemsNotificationText:
      "Sie haben zusätzliche Datenobjekte ausgewählt, die aufgrund Ihres Filters nicht sichtbar sind. Wenn Sie Aktionen ausführen, werden die sichtbaren und derzeit unsichtbaren Datenobjekte davon betroffen.",
    clearFilterMachineStructureToDragAndDrop:
      "Bitte verlassen Sie die Filteransicht in der Maschinenstruktur, um Drag & Drop wieder zu aktivieren.",
    maximumAmountOfMonitoringNodesExceededNotification:
      "Mögliche Latenz der Anwendung aufgrund von zu vielen Anforderungen für datenpunkte. Ersetzen Sie den Erfassungstyp für Überwachung durch Abfrage, um die Leistung der Anwendung zu verbessern.",
    blueprintAutomatchUnexpectedError:
      "Ein Fehler ist aufgetreten, während versucht wurde, das Blueprint automatisch abzugleichen.",
    blueprintLibraryUnexpectedError:
      "Ein Fehler ist aufgetreten, während versucht wurde, die Blueprint-Bibliothek abzurufen.",
  },
};

export const snackbarNotificationsZhHans = {
  [pageNameKey]: {
    hiddenItemsNotificationText:
      "您选择了额外的数据对象，由于您的过滤器，这些对象不可见。如果您执行任何操作，将影响可见和当前不可见的数据对象。",
    clearFilterMachineStructureToDragAndDrop:
      "请清除机器结构中的过滤器视图，以重新启用拖放功能。",
    maximumAmountOfMonitoringNodesExceededNotification:
      "由于监控数据点请求过多，可能会导致应用程序延迟。将监控采集类型替换为轮询，以提高应用程序性能。",
    blueprintAutomatchUnexpectedError: "尝试自动匹配蓝图时发生错误。",
    blueprintLibraryUnexpectedError: "尝试获取蓝图库时发生错误。",
  },
};

export const snackbarNotificationsIt = {
  [pageNameKey]: {
    hiddenItemsNotificationText:
      "Hai selezionato oggetti di dati aggiuntivi, che non sono visibili a causa del filtro. Se esegui qualsiasi azione, sia gli oggetti di dati visibili che quelli attualmente invisibili verranno interessati.",
    clearFilterMachineStructureToDragAndDrop:
      "Rimuovi il filtro nella struttura attiva per riattivare il drag and drop.",
    maximumAmountOfMonitoringNodesExceededNotification:
      "Possibile latenza dell'applicazione causata da troppi dati di monitoraggio richiesti. Se dovessero verificarsi rallentamenti sostituire il tipo di acquisizione del monitoraggio con polling per migliorare le prestazioni dell'app.",
    blueprintAutomatchUnexpectedError:
      "Si è verificato un errore durante il tentativo di abbinare automaticamente il Blueprint.",
    blueprintLibraryUnexpectedError:
      "Si è verificato un errore durante il tentativo di recuperare la libreria Blueprint.",
  },
};

export const snackbarNotificationsEs = {
  [pageNameKey]: {
    hiddenItemsNotificationText:
      "Ha seleccionado objetos de datos adicionales que no son visibles debido a su filtro. Si realiza alguna acción, los objetos de datos visibles y los que actualmente no son visibles se verán afectados.",
    clearFilterMachineStructureToDragAndDrop:
      "Por favor, borre la vista de filtro en la estructura de la máquina para volver a habilitar arrastrar y soltar.",
    maximumAmountOfMonitoringNodesExceededNotification:
      "Posible latencia de la aplicación causada por demasiadas solicitudes de puntos de datos de supervisión. Reemplace el tipo de adquisición de supervisión por sondeo para mejorar el rendimiento de la aplicación.",
    blueprintAutomatchUnexpectedError:
      "Se produjo un error al intentar hacer coincidir automáticamente el plano.",
    blueprintLibraryUnexpectedError:
      "Se produjo un error al intentar obtener la biblioteca de planos.",
  },
};

export const snackbarNotificationsNl = {
  [pageNameKey]: {
    blueprintAutomatchUnexpectedError:
      "Er is een fout opgetreden bij het automatisch matchen van de blueprint.",
    blueprintLibraryUnexpectedError:
      "Er is een fout opgetreden bij het ophalen van de blueprint-bibliotheek.",
    clearFilterMachineStructureToDragAndDrop:
      "Verlaat de filterweergave in de machinestructuur om Drag & Drop opnieuw te activeren.",
    hiddenItemsNotificationText:
      "U hebt extra gegevens-objecten geselecteerd die door uw filter niet zichtbaar zijn. Wanneer u acties uitvoert, hebben deze invloed op zowel de zichtbare als de momenteel verborgen gegevensobjecten.",
    maximumAmountOfMonitoringNodesExceededNotification:
      "Mogelijke vertraging van de toepassing door te veel aanvragen voor datapunten. Wijzig het verzamelingstype voor monitoring naar polling om de prestaties van de toepassing te verbeteren.",
  },
};

export const snackbarNotificationsTr = {
  [pageNameKey]: {
    blueprintAutomatchUnexpectedError:
      "Planı otomatik olarak eşleştirmeye çalışırken bir hata oluştu.",
    blueprintLibraryUnexpectedError:
      "Plan kitaplığı getirilmeye çalışılırken bir hata oluştu.",
    clearFilterMachineStructureToDragAndDrop:
      "Sürükle ve bırak özelliğini tekrar etkinleştirmek için lütfen makine yapısındaki filtre görünümünü temizleyin.",
    hiddenItemsNotificationText:
      "Filtreniz nedeniyle görünmeyen ek veri nesneleri seçtiniz. Herhangi bir eylem gerçekleştirirseniz, görünen ve o anda görünmeyen veri nesneleri etkilenecektir.",
    maximumAmountOfMonitoringNodesExceededNotification:
      "Çok fazla izleme veri noktası isteğinden kaynaklanan olası uygulama gecikmesi. Uygulama performansını artırmak için izleme edinme türünü yoklamayla değiştirin.",
  },
};
